import { Box, Typography } from '@mui/material';
import React from 'react';
import { Dropdown } from '../Dropdown';

interface AfterPeriodContentProps {
  periodValue: number | string;
  setPeriodValue: (value: number | string) => void;
  periodUnit: string;
  setPeriodUnit: (value: string) => void;
  anchorDate: string;
  setAnchorDate: (value: string) => void;
}

export const AfterPeriodContent: React.FC<AfterPeriodContentProps> = ({
  periodValue,
  setPeriodValue,
  periodUnit,
  setPeriodUnit,
  anchorDate,
  setAnchorDate,
}) => {
  const numberOptions = Array.from({ length: 30 }, (_, i) => i + 1).map(
    (num) => ({
      value: num,
      label: String(num),
    }),
  );

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: '12px', mt: '24px' }}
    >
      <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>
        Apply actions
      </Typography>
      <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        <Box sx={{ minWidth: 108 }}>
          <Dropdown
            value={periodValue}
            onChange={setPeriodValue}
            options={numberOptions}
            placeholder="Select"
          />
        </Box>
        <Dropdown
          value={periodUnit}
          onChange={(v) => setPeriodUnit(v as string)}
          options={[
            { value: 'Days', label: 'Days' },
            { value: 'Months', label: 'Months' },
            { value: 'Years', label: 'Years' },
          ]}
          placeholder="Select unit"
        />
      </Box>
      <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>After</Typography>
      <Dropdown
        value={anchorDate}
        onChange={(v) => setAnchorDate(v as string)}
        options={[
          { value: 'closure', label: 'Case closure date' },
          { value: 'submission', label: 'Case submission date' },
          { value: 'creation', label: 'Case creation date' },
          {
            value: 'unsubstantiation',
            label: 'Case unsubstantiation status date',
          },
        ]}
        placeholder="Select date reference"
      />
    </Box>
  );
};
